export const SET_NOTIFICATION = 'SET NOTIFICATION BY CASHIER ID';
export const SET_ERROR = 'SET ERROR';
export const SET_UNREAD_REQUIRE = 'SET UNREAD REQUIRE NOTIFICATION';
export const SET_ORDER_UNREAD_REQUIRE = 'SET ORDER UNREAD REQUIRE NOTIFICATION';
export const SET_UNREAD = 'SET UNREAD NOTIFICATION';
